export function cleanObject(obj: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {};

  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    const value = obj[key];
    if (!value) continue;

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        // Clean array by filtering out null and undefined values
        result[key] = value.filter(
          (item) => item !== null && item !== undefined
        );
      } else {
        // Recursively clean nested object
        result[key] = cleanObject(value);
      }
    } else {
      result[key] = value;
    }
  }

  return result;
}
